import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Button, Typography, Container, Autocomplete, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import configServ from '../../services/config';

const userRoles = ['Admin', 'Editor', 'Viewer']; // Define available roles

const userData = [
    { id: 1, name: 'User 1' },
    { id: 2, name: 'User 2' },
    { id: 3, name: 'User 3' },
    // Add more user data as needed
];

const AssignRolesPage = () => {
    const { user_id, is_super } = useSelector((state) => state.GlobalVariables);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedRole, setSelectedRole] = useState('');
    const [userList, setUserList] = useState([]);
    const [filterUserList, setFilterUserList] = useState([]);;
    const [count, setCount] = useState(0)

    useEffect(() => {
        fetchUserList();
    }, []);

    const fetchUserList = async () => {
        try {
            const result = await configServ.getAccessMasterUser({ "user_id": user_id, "is_super": is_super === 1 ? true : false });
            if (result.status === 200) {
                setUserList(result.data);
                setFilterUserList(result.data);
                setCount(result.data.length);
            }
            else {
                setUserList([]);
                setFilterUserList([]);
                setCount(0);
            }
        }
        catch (error) {
            console.log(error);
        }
        finally {

        }
    }

    const handleUserChange = (event, newValue) => {
        setSelectedUser(newValue);
    };

    const handleRoleChange = (event) => {
        setSelectedRole(event.target.value);
    };

    const handleAssignRole = () => {
        // Implement your logic to assign the selected role to the user
        console.log(`Assigned ${selectedRole} role to ${selectedUser.name}`);
        // Clear the selection after assignment
        setSelectedUser(null);
        setSelectedRole('');
    };

    return (
        <Container>
            <Typography variant="h4">Assign Roles</Typography>
            <Autocomplete
                id="user-demo"
                clearOnEscape
                options={userList}
                getOptionLabel={(option) => `${option.name} (${option.user_name})`}
                value={selectedUser}
                onChange={handleUserChange}
                renderInput={(params) => <TextField {...params} label="USER" />}
            />

            {selectedUser && (
                <FormControl style={{ minWidth: 200, marginTop: 16 }}>
                    <InputLabel>Select Role</InputLabel>
                    <Select value={selectedRole} onChange={handleRoleChange}>
                        <MenuItem value="">Select Role</MenuItem>
                        {userRoles.map((role) => (
                            <MenuItem key={role} value={role}>
                                {role}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}

            {selectedUser && selectedRole && (
                <div style={{ marginTop: 16 }}>
                    <Button variant="contained" color="primary" onClick={handleAssignRole}>
                        Assign Role
                    </Button>
                </div>
            )}
        </Container>
    );
};

export default AssignRolesPage;
